<template>
  <div class="section-hero sectionBackGround" ref="scrollContainer">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-2">
          <card class="border-0 text-left" hover shadow body-classes="py-3" style="margin-top: 20px;">
            <!-- 左侧导航栏内容 -->
          </card>
        </div>
        <div class="col-lg-10">
          <card style="margin-top: 20px;">
            <div class="btn-wrapper" style="position: relative;">
              <base-input ref="searchInput"
                style="border-radius: 4px; background: rgba(155, 165, 175, 0.10); color: #333; font-family: 'Noto Sans S Chinese';"
                v-model="searchQuery" @keyup.enter="handleSearch" alternative placeholder="二型糖尿病">
              </base-input>

              <i class="fa fa-search search-icon" @click="handleSearch"></i>
              <i
                class="fa fa-times search-icon"
                @click="clearSearch"
                style="margin-right: 30px;"
                v-if="searchQuery">
              </i>
            </div>
            <!-- <hr class="divider" /> -->
            <div class="image-tile"></div>

            <div v-if="loading" class="text-center mt-5">
              <p>正在加载...</p>
            </div>

            <div v-else-if="searchResults.length === 0" class="text-center mt-5">
              <p>没有找到相关结果，请尝试其他关键词。</p>
            </div>

            <div v-else>
              <div v-for="result in paginatedResults" :key="result.id" class="mt-0">
                <div class="nav-link" style="margin-top: 0; cursor: pointer;">
                  <h6 class="text-uppercase" @click="viewDocumentDetail(result.id)"
                    style="color: #333; background-color: #fff; font-family: 'Noto Sans S Chinese'; font-size: 20px; font-weight: 500; line-height: 28px; letter-spacing: 1px;">
                    {{ result.articletitle }}
                  </h6>
                  <div>
                    <badge
                      style="color: #7D7E80; background-color: #fff; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px;">
                      <i class="fa fa-circle-o-notch" aria-hidden="true"></i>
                    </badge>
                      
                    <badge style="color: #7D7E80; 
                      background-color: #ECEDEF; 
                      font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 14px;">
                      {{result.articletags }}
                    </badge>
                      
                    <badge
                      style="color: #7D7E80; background-color: #fff;font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px;">
                      <i class="fa fa-star-o" aria-hidden="true"></i> 推荐评分 {{ result.recommendationscore }}
                    </badge>
                    <badge
                      style="color: #7D7E80; background-color: #fff; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px;">
                      <i class="fa fa-heart-o" aria-hidden="true"></i> 收藏
                    </badge>
               
					<span
  style="color: #7D7E80; background-color: #fff; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px; cursor: pointer;"
  @click.stop="openLinkInNewWindow(result.articleurl)"
>
  <i class="fa fa-link" aria-hidden="true"></i> 打开链接
</span>
                  </div>
                    
                 <p class="description mt-2" @click="viewDocumentDetail(result.id)"
                   style="color: #333; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px; letter-spacing: 1px;">
                   <span v-if="result.articleabstract">{{ result.articleabstract.substring(0, 200) }}...</span>
                   <span v-else>暂无摘要</span>
                 </p>
                </div>
              </div>
            </div>

            <div v-if="searchResults.length > 0 && totalPages > 1" class="pagination-controls mt-4 text-center">
              <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-center" style="margin-bottom: 50px">
                  <li class="page-item" :class="{ disabled: currentPage <= 1 }" @click="prevPage">
                    <a class="page-link" href="#">
                      <i class="fa fa-angle-left"></i>
                      <span class="sr-only">Previous</span>
                    </a>
                  </li>
                  <li class="page-item" :class="{ active: page === currentPage }" v-for="page in visiblePages" :key="page" @click="FunCurrentPage(page)">
                    <a class="page-link" href="#">{{ page }}</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage >= totalPages }" @click="nextPage">
                    <a class="page-link" href="#">
                      <i class="fa fa-angle-right"></i>
                      <span class="sr-only">Next</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

      
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "DocQueryList",
  data() {
    return {
      searchQuery: '',
      searchResults: [],
      page: 1,
      totalDocuments: 0,
      currentPage: 1,
      itemsPerPage: 10,
      scrollPosition: 0, // 当前滚动位置

      loading: false,
      pagination: {
        default: 1
      },
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalDocuments / this.itemsPerPage);
    },
    paginatedResults() {
      return this.searchResults;
    },
    visiblePages() {
      // 生成可见的页码，这里简化为当前页和相邻的两页
      let pages = [];
      for (let i = this.currentPage - 2; i <= this.currentPage + 2; i++) {
        if (i > 0 && i <= this.totalPages) {
          pages.push(i);
        }
      }
      return pages;
    }
  },
  watch: {
    '$route.query.searchQuery': {
      immediate: true,
      handler(newQuery) {
        if (newQuery) {
          this.searchQuery = newQuery;
          const page = this.$route.query.page;
          if (page) {
            this.currentPage = Number(page);
          }
          this.search(false).then(() => {
            this.restoreScrollPosition();
          });
        }
      }
    }
  },
  methods: {
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
    async search(resetPage = false) {
      const token = this.getCookie('token');
      if (!token) {
        this.$router.push('/login');
        return;
      }

      if (this.searchQuery.trim() === '') {
        this.searchResults = [];
        this.totalDocuments = 0;
        return;
      }

      if (resetPage) {
        this.currentPage = 1;
      }

      this.loading = true;
      try {
        const params = new URLSearchParams();
        params.append('keywords', this.searchQuery);
        params.append('token', token);
        params.append('page', this.currentPage);
        params.append('itemsPerPage', this.itemsPerPage);

        const response = await axios.post('https://anthromindxx.com/ca.php?action=search', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
        if (response.data.success) {
          this.searchResults = response.data.posts;
		  console.log(this.searchResults)
          this.totalDocuments = response.data.totalDocuments;
          this.itemsPerPage = response.data.itemsPerPage || this.itemsPerPage;
        } else {
          this.searchResults = [];
          this.totalDocuments = 0;
        }

      } catch (error) {
        console.error('Search failed:', error);
        this.searchResults = [];
        this.totalDocuments = 0;
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.search(true).then(() => {
        this.restoreScrollPosition();
      });
    },
    clearSearch() {
      this.searchQuery = '';
      this.$refs.searchInput.focus();
    },
    viewDocumentDetail(id) {
      const scrollContainer = this.$refs.scrollContainer;
      if (scrollContainer) {
        this.scrollPosition = scrollContainer.scrollTop;
        sessionStorage.setItem('scrollPosition', this.scrollPosition);
        //console.log('Stored scroll position:', this.scrollPosition);
      } else {
        console.warn('Scroll container not found!');
      }

      sessionStorage.setItem('searchResults', JSON.stringify(this.searchResults));
      this.$router.push({
        path: '/DocQueryListdetail',
        query: { id: id, searchQuery: this.searchQuery, page: this.currentPage }
      });
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.search().then(() => {
          this.restoreScrollPosition();
        });
      }
    },
    FunCurrentPage(valPage) {
      this.currentPage = valPage;
      this.search().then(() => {
        this.restoreScrollPosition();
      });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.search().then(() => {
          this.restoreScrollPosition();
        });
      }
    },
    updateScrollPosition() {
      const scrollContainer = this.$refs.scrollContainer;
      if (scrollContainer) {
        this.scrollPosition = scrollContainer.scrollTop;
     //   console.log('当前滚动位置:', this.scrollPosition);
      }
    },
    restoreScrollPosition() {
      const storedScrollPosition = sessionStorage.getItem('scrollPosition');
     // console.log('Retrieved scroll position:', storedScrollPosition);

      if (storedScrollPosition) {
        this.$nextTick(() => {
          const scrollContainer = this.$refs.scrollContainer;
          if (scrollContainer) {
            scrollContainer.scrollTo(0, Number(storedScrollPosition));
          //  console.log('Scrolled to position:', storedScrollPosition);
          }
        });
        sessionStorage.removeItem('scrollPosition');
      }
    },
    // 阻止badge上的点击事件冒泡到父级<a>标签
    preventClick(event) {
      event.stopPropagation();
    },
    
    openLinkInNewWindow(url) {
      if (url) {
        window.open(url, '_blank');
      } else {
        console.warn('URL is not defined.');
      }
    },
  },
  async created() {
    const searchQuery = this.$route.query.searchQuery;
    const page = this.$route.query.page;
    if (searchQuery) {
      this.searchQuery = searchQuery;
      if (page) {
        this.currentPage = Number(page);
      }
      await this.search(false);
      this.restoreScrollPosition();
    } else {
      this.searchResults = [];
      this.totalDocuments = 0;
    }
  },
  mounted() {
    const scrollContainer = this.$refs.scrollContainer;
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', this.updateScrollPosition);
 //     console.log('Scroll container found and event listener added.');
    } else {
      console.warn('Scroll container not found on mounted!');
    }
  },
  beforeDestroy() {
    const scrollContainer = this.$refs.scrollContainer;
    if (scrollContainer) {
      scrollContainer.removeEventListener('scroll', this.updateScrollPosition);
 //     console.log('Scroll container found and event listener removed.');
    }
  }
};
</script>

<style scoped>
.sectionBackGround {
  min-height: calc(100vh - 48px);
  background-image: url('https://anthromindxx.com/ant/bj.jpeg');
  background-position: center center;
  background-attachment: fixed;
  background-size: 100% 100%;
  overflow-y: auto; /* 确保容器可以滚动 */
  padding-bottom: 100px;
}

@media (max-width: 600px) {
  .sectionBackGround {
    height: 300px;
    overflow-y: scroll;
  }
}

.search-icon {
  color: #0ff5c8;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
}

.pagination-controls {
  margin-top: 20px;
  margin-bottom: 20px;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #ccc;
  margin-top: 5px;
}

.div1 {
  align-self: stretch;
  position: relative;
  letter-spacing: 2px;
  line-height: 20px;
}

.child {
  width: 600px;
  position: relative;
  height: 4px;
}

.div {
  width: 100%;
  position: relative;
  height: 65px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  text-align: left;
  font-size: 14px;
  color: rgba(51, 51, 51, 0.6);
  font-family: 'Noto Sans S Chinese';
}

.image-tile {
  width: 100%;
  height: 35px;
  background-image: url('https://anthromindxx.com//ant/ssjg.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.debug-info {
  position: fixed;
  bottom: 10px;
  right: 10px;
  background: rgba(0,0,0,0.7);
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  z-index: 1000;
  font-size: 14px;
}
</style>